import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの支払方法一覧を取得する
 *
 * @param {Number} uid ユーザID
 * @returns {Response} レスポンスデータ
 */
export function getUserPayments (uid) {
  return request.get(`/users/${uid}/payments`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
